import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from '../locales/en.json';
import ko from '../locales/ko.json';

// 从 URL 参数中获取语言设置，默认为英文
const getLanguageFromUrl = (): string => {
  if (typeof window === 'undefined') {
    return 'en'; // SSR 环境默认返回英文
  }

  const urlParams = new URLSearchParams(window.location.search);
  const langParam = urlParams.get('lang');

  // 如果 URL 参数中有 lang 且值为 'ko'，则使用韩语，否则使用英文
  if (langParam === 'ko') {
    return 'ko';
  }

  return 'en'; // 默认英文
};

const defaultLanguage = getLanguageFromUrl();

const resources = {
  en: {
    translation: en,
  },
  ko: {
    translation: ko,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: defaultLanguage,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;

